import { useQuery } from "@tanstack/react-query";
import api from "../utils/axios";

// Get all company subscriptions (admin)
export const useGetCompanySubscriptionsAdmin = (params = {}, options = {}) =>
  useQuery({
    queryKey: ["companySubscriptions", "admin", params],
    queryFn: async () => {
      const res = await api.get("/admin/companySubscription", { params });
      return res.data;
    },
    staleTime: 2 * 60 * 1000,
    ...options,
  });